module.exports = __webpack_public_path__ + "static/media/verify_profile.dc212a1a.png";